(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["red-cotton-bundle-upsell-block"] && !Shopify.designMode) return;
  try {
    (function () {
  function initBundle(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var listEl = root.querySelector('[data-rcb-list]');
    var totalEl = root.querySelector('[data-rcb-total]');
    var totalCompareEl = root.querySelector('[data-rcb-total-compare]');
    var addButton = root.querySelector('[data-rcb-add]');
    var statusEl = root.querySelector('[data-rcb-status]');

    var isArabic =
      document.documentElement.lang.toLowerCase().indexOf('ar') === 0 ||
      document.documentElement.dir === 'rtl';

    var currentProductId = Number(root.dataset.productId);
    var mode = root.dataset.mode || 'related';
    var hideSoldOut = root.dataset.hideSoldOut === 'true';
    var hasManualRule = root.dataset.manualRule === 'true';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var rootUrl = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
    var moneyFormat = root.dataset.moneyFormat || '';
    var currency = root.dataset.currency || 'EGP';

    var currentProduct = {};
    var manualProducts = [];
    var collectionProducts = [];

    try {
      currentProduct = JSON.parse(root.querySelector('[data-rcb-current]').textContent || '{}');
    } catch (e) {}

    try {
      manualProducts = JSON.parse(root.querySelector('[data-rcb-manual]').textContent || '[]');
    } catch (e) {}

    try {
      collectionProducts = JSON.parse(root.querySelector('[data-rcb-collection]').textContent || '[]');
    } catch (e) {}

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function imageOf(product) {
      if (!product) return '';
      if (typeof product.image === 'string') return product.image;
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image && product.featured_image.src) return product.featured_image.src;

      if (Array.isArray(product.images) && product.images.length) {
        if (typeof product.images[0] === 'string') return product.images[0];
        if (product.images[0] && product.images[0].src) return product.images[0].src;
      }

      return '';
    }

    function normalize(product) {
      return {
        id: Number(product.id),
        title: product.title || '',
        url: product.url || '#',
        image: imageOf(product),
        selected_variant_id: Number(product.selected_variant_id) || 0,
        variants: (Array.isArray(product.variants) ? product.variants : []).map(function (variant) {
          return {
            id: Number(variant.id),
            title: variant.title || '',
            available: variant.available !== false,
            price: Number(variant.price) || 0,
            compare_at_price: Number(variant.compare_at_price) || 0
          };
        })
      };
    }

    function availableVariants(product) {
      return product.variants.filter(function (variant) {
        return variant.available;
      });
    }

    function hasAvailable(product) {
      return availableVariants(product).length > 0;
    }

    function cleanSuggestions(products) {
      var seen = {};

      return (products || [])
        .map(normalize)
        .filter(function (product) {
          if (!product.id || product.id === currentProductId) return false;
          if (seen[product.id]) return false;
          if (hideSoldOut && !hasAvailable(product)) return false;

          seen[product.id] = true;
          return true;
        })
        .slice(0, 2);
    }

    function formatMoney(cents) {
      if (
        moneyFormat &&
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      try {
        return new Intl.NumberFormat(isArabic ? 'ar-EG' : 'en-EG', {
          style: 'currency',
          currency: currency,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function firstVariant(product, isCurrent) {
      var variants = availableVariants(product);

      if (!variants.length) {
        variants = product.variants.slice();
      }

      if (isCurrent && product.selected_variant_id) {
        var selected = variants.find(function (variant) {
          return variant.id === product.selected_variant_id;
        });

        if (selected) return selected;
      }

      return variants[0] || null;
    }

    function card(product, isCurrent) {
      var variants = availableVariants(product);

      if (!variants.length && hideSoldOut) return '';
      if (!variants.length) variants = product.variants.slice();
      if (!variants.length) return '';

      var first = firstVariant(product, isCurrent);
      if (!first) return '';

      var realOptions =
        !(variants.length === 1 && String(variants[0].title).toLowerCase() === 'default title');

      var options = variants.map(function (variant) {
        return '<option value="' + variant.id +
          '" data-price="' + variant.price +
          '" data-compare="' + variant.compare_at_price + '"' +
          (variant.id === first.id ? ' selected' : '') +
          '>' + esc(variant.title) + '</option>';
      }).join('');

      var variantControl = realOptions
        ? '<select class="rcb-variant" data-variant aria-label="' +
          esc(isArabic ? 'اختر المقاس أو الخيار' : 'Choose option') +
          '">' + options + '</select>'
        : '<input type="hidden" data-variant value="' + first.id +
          '" data-price="' + first.price +
          '" data-compare="' + first.compare_at_price + '">';

      var compare =
        first.compare_at_price > first.price
          ? formatMoney(first.compare_at_price)
          : '';

      var image = product.image
        ? '<img class="rcb-image" src="' + esc(product.image) +
          '" alt="' + esc(product.title) + '" loading="lazy">'
        : '';

      return '' +
        '<div class="rcb-card' + (isCurrent ? ' rcb-card--current' : '') +
        '" data-card data-current="' + (isCurrent ? 'true' : 'false') + '">' +

          '<div class="rcb-select-col">' +
            (
              isCurrent
                ? '<span aria-hidden="true"></span>'
                : '<input class="rcb-checkbox" type="checkbox" checked data-check aria-label="' +
                  esc(isArabic ? 'اختيار المنتج' : 'Select product') +
                  '">'
            ) +
          '</div>' +

          '<div class="rcb-content">' +
            (
              isCurrent
                ? '<div class="rcb-current-label">' +
                  esc(isArabic ? 'المنتج الحالي' : 'Current product') +
                  '</div>'
                : ''
            ) +

            '<a class="rcb-product-title" href="' + esc(product.url) + '">' +
              esc(product.title) +
            '</a>' +

            '<div class="rcb-prices">' +
              '<span class="rcb-compare" data-card-compare>' + compare + '</span>' +
              '<span class="rcb-price" data-card-price>' + formatMoney(first.price) + '</span>' +
            '</div>' +

            variantControl +
          '</div>' +

          '<a class="rcb-image-link" href="' + esc(product.url) +
          '" aria-label="' + esc(product.title) + '">' +
            image +
          '</a>' +
        '</div>';
    }

    function variantData(cardEl) {
      var control = cardEl.querySelector('[data-variant]');
      if (!control) return null;

      if (control.tagName === 'SELECT') {
        var option = control.options[control.selectedIndex];

        return {
          id: Number(option.value),
          price: Number(option.dataset.price) || 0,
          compare: Number(option.dataset.compare) || 0
        };
      }

      return {
        id: Number(control.value),
        price: Number(control.dataset.price) || 0,
        compare: Number(control.dataset.compare) || 0
      };
    }

    function syncCard(cardEl) {
      if (!cardEl) return;

      var variant = variantData(cardEl);
      if (!variant) return;

      var priceEl = cardEl.querySelector('[data-card-price]');
      var compareEl = cardEl.querySelector('[data-card-compare]');

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (compareEl) {
        compareEl.textContent =
          variant.compare > variant.price
            ? formatMoney(variant.compare)
            : '';
      }
    }

    function updateTotal() {
      var total = 0;
      var compareTotal = 0;
      var selectedCount = 0;

      listEl.querySelectorAll('[data-card]').forEach(function (cardEl) {
        var current = cardEl.dataset.current === 'true';
        var checkbox = cardEl.querySelector('[data-check]');

        if (!current && checkbox && !checkbox.checked) return;

        var variant = variantData(cardEl);
        if (!variant) return;

        selectedCount++;
        total += variant.price;
        compareTotal +=
          variant.compare > variant.price
            ? variant.compare
            : variant.price;
      });

      totalEl.textContent = formatMoney(total);

      totalCompareEl.textContent =
        compareTotal > total
          ? formatMoney(compareTotal)
          : '';

      addButton.disabled = selectedCount === 0;
    }

    function render(suggestions) {
      currentProduct = normalize(currentProduct);

      if (!currentProduct.id || !hasAvailable(currentProduct)) {
        root.hidden = true;
        return;
      }

      suggestions = cleanSuggestions(suggestions);

      if (!suggestions.length) {
        root.hidden = true;
        return;
      }

      var products = [currentProduct].concat(suggestions);

      listEl.innerHTML = products.map(function (product, index) {
        var html = card(product, index === 0);

        if (index < products.length - 1) {
          html += '<div class="rcb-plus" aria-hidden="true">+</div>';
        }

        return html;
      }).join('');

      root.hidden = false;

      listEl.querySelectorAll('[data-check],[data-variant]').forEach(function (control) {
        control.addEventListener('change', function () {
          syncCard(control.closest('[data-card]'));
          updateTotal();
        });
      });

      updateTotal();
    }

    function selectedItems() {
      var items = [];

      listEl.querySelectorAll('[data-card]').forEach(function (cardEl) {
        var current = cardEl.dataset.current === 'true';
        var checkbox = cardEl.querySelector('[data-check]');

        if (!current && checkbox && !checkbox.checked) return;

        var variant = variantData(cardEl);

        if (variant && variant.id) {
          items.push({
            id: variant.id,
            quantity: 1
          });
        }
      });

      return items;
    }

    addButton.addEventListener('click', function () {
      var items = selectedItems();
      if (!items.length) return;

      var originalText = addButton.textContent;

      addButton.disabled = true;
      addButton.textContent = isArabic ? 'جاري الإضافة...' : 'Adding...';
      statusEl.textContent = '';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || data.message || 'Cart error');
          });
        }

        return response.json();
      })
      .then(function () {
        statusEl.textContent =
          isArabic
            ? 'تمت إضافة المجموعة للسلة.'
            : 'Bundle added to cart.';

        window.setTimeout(function () {
          window.location.href = cartUrl;
        }, 300);
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.textContent = originalText;

        statusEl.textContent =
          isArabic
            ? 'تعذر إضافة المنتجات. جرّب مرة أخرى.'
            : 'Could not add the products. Please try again.';
      });
    });

    function loadRelated() {
      var url =
        rootUrl +
        'recommendations/products.json?product_id=' +
        encodeURIComponent(currentProductId) +
        '&limit=10&intent=related';

      fetch(url, {
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recommendations unavailable');
        }

        return response.json();
      })
      .then(function (data) {
        render(data.products || []);
      })
      .catch(function () {
        root.hidden = true;
      });
    }

    if (hasManualRule) {
      render(manualProducts);
      return;
    }

    if (mode === 'collection') {
      render(collectionProducts);
      return;
    }

    loadRelated();
  }

  function initAll(scope) {
    var container = scope || document;

    container.querySelectorAll('[data-rcb-root]').forEach(function (root) {
      initBundle(root);
    });
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
